(function () {
  'use strict';

  var ITEM_GAP = 8; // px — 0.8rem at 10px base
  var OPACITIES = [1, 0.6, 0.2];

  // ---------- List card ----------

  function initList(container) {
    var animEnabled = container.dataset.animEnabled !== 'false';
    var TICK_MS = parseInt(container.dataset.tick, 10) || 2500;
    var TRANS_MS = parseInt(container.dataset.trans, 10) || 600;

    var items = Array.from(container.querySelectorAll('.nb-mc2-list-item'));
    var n = items.length;
    if (n < 2) return;

    var itemH = items[0].offsetHeight;
    if (!itemH) return;

    var STEP = itemH + ITEM_GAP;

    container.style.height = (n * STEP - ITEM_GAP) + 'px';
    container.classList.add('nb-mc2-list--ready');

    items.forEach(function (item) {
      item.style.willChange = 'transform, opacity';
    });

    var offset = 0;

    function rank(i) {
      return ((i - offset) % n + n) % n;
    }

    items.forEach(function (item, i) {
      item.style.transition = 'none';
      item.style.transform = 'translateY(' + (rank(i) * STEP) + 'px)';
      item.style.opacity = OPACITIES[rank(i)] !== undefined ? OPACITIES[rank(i)] : 0;
    });

    var timer = null;

    function tick() {
      var topIdx = -1;
      for (var i = 0; i < n; i++) {
        if (rank(i) === 0) { topIdx = i; break; }
      }

      items.forEach(function (item, i) {
        var nextRank = rank(i) - 1;
        item.style.transition = 'transform ' + TRANS_MS + 'ms ease, opacity ' + TRANS_MS + 'ms ease';
        item.style.transform = 'translateY(' + (nextRank * STEP) + 'px)';
        item.style.opacity = nextRank < 0
          ? '0'
          : String(OPACITIES[nextRank] !== undefined ? OPACITIES[nextRank] : 0);
      });

      timer = setTimeout(function () {
        offset = (offset + 1) % n;

        items[topIdx].style.transition = 'none';
        items[topIdx].style.transform = 'translateY(' + ((n - 1) * STEP) + 'px)';
        items[topIdx].style.opacity = '0';

        void items[topIdx].offsetHeight;

        items[topIdx].style.transition = 'opacity ' + TRANS_MS + 'ms ease';
        items[topIdx].style.opacity = String(OPACITIES[n - 1] !== undefined ? OPACITIES[n - 1] : 0);

        timer = setTimeout(tick, TICK_MS);
      }, TRANS_MS);
    }

    if (animEnabled) {
      timer = setTimeout(tick, TICK_MS);
    }

    container._nbMc2Stop = function () {
      clearTimeout(timer);
    };
  }

  // ---------- Graph card ----------

  function initGraph(container) {
    if (container._nbMc2GraphInit) return;
    container._nbMc2GraphInit = true;

    var NS = 'http://www.w3.org/2000/svg';

    // ViewBox matches the card content area in Figma (Frame 154: 338.667 x 150)
    var W = 338.667, H = 150;

    // Layout zones (SVG user units, taken from Figma)
    var ROW_H    = 20;    // ABOVE / BELOW row height
    var DIV_Y1   = 24;    // first divider y
    var BAND_TOP = 28;    // IN RANGE band top
    var BAND_BOT = 122;   // IN RANGE band bottom
    var DIV_Y2   = 126;   // second divider y
    var BLW_Y    = 130;   // BELOW row top
    var BAND_H   = BAND_BOT - BAND_TOP; // 94

    // Dot centers from Figma (Frame 154 coordinate space)
    // P1(16.7) upper-left  P2(10.0) lower-middle  P3(12.5) upper-right
    var pts = [
      { x: 157.32, y: 71,    label: '16.7' },
      { x: 244.04, y: 100,   label: '10.0' },
      { x: 329.35, y: 90.99, label: '12.5' }
    ];

    var PILL_W = 6, PILL_RX = 3;
    var DOT = 12, DOT_RX = 4;
    var FS = 12, LBL_GAP = 4, LBL_H = 17;

    var C_GRAY   = '#d9d9d9';
    var C_BLUE   = '#2760d8';
    var C_IN_LBL = '#5280e0';
    var C_LABEL  = '#717680';
    var C_LINE   = '#9db3dc';
    var C_DIV    = '#e0e0e0';

    var RISE_MS = 650, STAGGER_MS = 140, START_MS = 150, LINE_MS = 550;
    var reduceMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var graphId = container.dataset.graphId || String(Date.now());
    var gradId  = 'nbMc2Grad_'  + graphId;
    var clipId  = 'nbMc2Clip_'  + graphId;

    function svgEl(tag, attrs) {
      var e = document.createElementNS(NS, tag);
      for (var k in attrs) e.setAttribute(k, attrs[k]);
      return e;
    }

    function pill(x, y, h, fill) {
      return svgEl('rect', { x: x, y: y, width: PILL_W, height: h, rx: PILL_RX, ry: PILL_RX, fill: fill });
    }

    function rowText(x, cy, str, color, weight) {
      var t = svgEl('text', {
        x: x, y: cy, 'dominant-baseline': 'central',
        'font-size': FS, fill: color
      });
      if (weight) t.setAttribute('font-weight', weight);
      t.textContent = str;
      return t;
    }

    var svg = svgEl('svg', {
      viewBox: '0 0 ' + W + ' ' + H,
      width: '100%',
      height: '100%',
      preserveAspectRatio: 'xMidYMid meet'
    });

    // ---- defs: horizontal gradient + vertical clip for the band ----
    var defs = document.createElementNS(NS, 'defs');

    var grad = svgEl('linearGradient', { id: gradId, x1: '0', y1: '0', x2: '1', y2: '0', gradientUnits: 'objectBoundingBox' });
    grad.appendChild(svgEl('stop', { offset: '0%',   'stop-color': '#ffffff' }));
    grad.appendChild(svgEl('stop', { offset: '50%',  'stop-color': '#d4dff7' }));
    grad.appendChild(svgEl('stop', { offset: '100%', 'stop-color': '#ffffff' }));
    defs.appendChild(grad);

    // Clip the rising dots to the band's top/bottom edges (full width left open)
    var clip = svgEl('clipPath', { id: clipId });
    clip.appendChild(svgEl('rect', { x: -8, y: BAND_TOP, width: W + 16, height: BAND_H }));
    defs.appendChild(clip);

    svg.appendChild(defs);

    // ---- rise keyframe (per-dot distance via the --rise custom property) ----
    var styleEl = document.createElementNS(NS, 'style');
    styleEl.textContent =
      '@keyframes nbMc2DotRise{' +
        'from{transform:translateY(var(--rise,60px));opacity:0}' +
        '60%{opacity:1}' +
        'to{transform:translateY(0);opacity:1}' +
      '}';
    svg.appendChild(styleEl);

    // ---- ABOVE RANGE row ----
    svg.appendChild(pill(0, 0, ROW_H, C_GRAY));
    svg.appendChild(rowText(PILL_W + 8, ROW_H / 2, container.dataset.above || 'ABOVE RANGE', C_LABEL));

    // ---- divider 1 ----
    svg.appendChild(svgEl('line', { x1: 0, y1: DIV_Y1 + 0.5, x2: W, y2: DIV_Y1 + 0.5, stroke: C_DIV, 'stroke-width': 1, 'stroke-dasharray': '4 4' }));

    // ---- IN RANGE band ----
    svg.appendChild(svgEl('rect', { x: 0, y: BAND_TOP, width: W, height: BAND_H, fill: 'url(#' + gradId + ')' }));
    svg.appendChild(pill(0, BAND_TOP + 4, BAND_H - 8, C_BLUE));
    svg.appendChild(rowText(PILL_W + 8, BAND_TOP + BAND_H / 2, container.dataset.inRange || 'IN RANGE', C_IN_LBL, 600));

    // ---- animated chart content (clipped to the band) ----
    var chartGroup = svgEl('g', { 'clip-path': 'url(#' + clipId + ')' });

    var polyline = svgEl('polyline', {
      points: pts.map(function (p) { return p.x + ',' + p.y; }).join(' '),
      fill: 'none',
      stroke: C_LINE,
      'stroke-width': '1.5',
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round'
    });

    // Length of the connecting line, for the draw-on transition
    var lineLen = 0;
    for (var s = 1; s < pts.length; s++) {
      lineLen += Math.hypot(pts[s].x - pts[s - 1].x, pts[s].y - pts[s - 1].y);
    }
    polyline.style.strokeDasharray = lineLen;
    polyline.style.strokeDashoffset = reduceMotion ? '0' : lineLen;
    polyline.style.opacity = reduceMotion ? '1' : '0';
    chartGroup.appendChild(polyline);

    var dotGroups = [];
    pts.forEach(function (p, i) {
      var g = document.createElementNS(NS, 'g');

      var txt = svgEl('text', {
        x: p.x, y: p.y - DOT / 2 - LBL_GAP - LBL_H / 2,
        'text-anchor': 'middle', 'dominant-baseline': 'central',
        'font-size': FS, fill: C_LABEL
      });
      txt.textContent = p.label;
      g.appendChild(txt);

      g.appendChild(svgEl('rect', { x: p.x - DOT / 2, y: p.y - DOT / 2, width: DOT, height: DOT, rx: DOT_RX, ry: DOT_RX, fill: C_BLUE }));

      if (!reduceMotion) {
        // Start each dot just below the band's bottom edge so it rises into view
        g.style.setProperty('--rise', (BAND_BOT + 25 - p.y) + 'px');
        g.style.animation = 'nbMc2DotRise ' + RISE_MS + 'ms cubic-bezier(0.34,1.56,0.64,1) ' +
          (START_MS + i * STAGGER_MS) + 'ms both';
        g.style.animationPlayState = 'paused';
      }

      dotGroups.push(g);
      chartGroup.appendChild(g);
    });

    svg.appendChild(chartGroup);

    // ---- divider 2 ----
    svg.appendChild(svgEl('line', { x1: 0, y1: DIV_Y2 + 0.5, x2: W, y2: DIV_Y2 + 0.5, stroke: C_DIV, 'stroke-width': 1, 'stroke-dasharray': '4 4' }));

    // ---- BELOW RANGE row ----
    svg.appendChild(pill(0, BLW_Y, ROW_H, C_GRAY));
    svg.appendChild(rowText(PILL_W + 8, BLW_Y + ROW_H / 2, container.dataset.below || 'BELOW RANGE', C_LABEL));

    container.appendChild(svg);

    // ---- replay animation every time the graph enters the viewport ----
    function resetAndPlay() {
      polyline.style.transition = 'none';
      polyline.style.opacity = '0';
      polyline.style.strokeDashoffset = lineLen;

      dotGroups.forEach(function (g, i) {
        g.style.animation = 'none';
      });

      void container.offsetHeight; // force reflow

      dotGroups.forEach(function (g, i) {
        g.style.setProperty('--rise', (BAND_BOT + 25 - pts[i].y) + 'px');
        g.style.animation = 'nbMc2DotRise ' + RISE_MS + 'ms cubic-bezier(0.34,1.56,0.64,1) ' +
          (START_MS + i * STAGGER_MS) + 'ms both';
      });

      setTimeout(function () {
        polyline.style.transition = 'stroke-dashoffset ' + LINE_MS + 'ms ease, opacity 200ms ease';
        polyline.style.opacity = '1';
        polyline.style.strokeDashoffset = '0';
      }, START_MS + (pts.length - 1) * STAGGER_MS + RISE_MS);
    }

    if (reduceMotion) {
      return;
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { resetAndPlay(); }
        });
      }, { threshold: 0.3 });
      io.observe(container);
    } else {
      resetAndPlay();
    }
  }

  // ---------- Section init ----------

  function initSection(root) {
    root.querySelectorAll('.nb-mc2-list').forEach(initList);
    root.querySelectorAll('[data-graph-id]').forEach(initGraph);
  }

  function init() {
    initSection(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initSection(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('.nb-mc2-list').forEach(function (el) {
      if (el._nbMc2Stop) el._nbMc2Stop();
    });
    e.target.querySelectorAll('[data-graph-id]').forEach(function (area) {
      area._nbMc2GraphInit = false;
      var existing = area.querySelector('svg');
      if (existing) area.removeChild(existing);
    });
  });
})();
